<script setup lang="ts">
/**
 * PAGE CAGNOTTE — « Coup de cœur Donoor » : quelques mots de l'équipe Donoor sur
 * la cagnotte, écrits dans le backup-manager (Karim 2026-10-12).
 */
import MascotteCoeurs from "~/components/shared/MascotteCoeurs.vue";

defineProps<{ texte: string }>();
</script>

<template>
  <div class="relative flex flex-col rounded-[24px] border-2 border-dashed border-(--color-ink) bg-white px-7 pt-8 pb-7">
    <!-- Pastille étoilée noire avec la mascotte qui lance des cœurs, à cheval sur le coin -->
    <MascotteCoeurs class="!absolute -top-6 -right-4" />

    <p class="text-lg text-(--color-ink)" style="font-weight: 700 !important">{{ $t("campagne.pageCagnotte.coupDeCoeur") }}</p>
    <p class="mt-3 text-[15px] leading-[1.75] text-(--color-ink)">{{ texte }}</p>
    <p class="mt-auto pt-5 flex items-center gap-2 text-xs text-gray-500">
      <!-- Logo Donoor : D noir, cœur blanc -->
      <img src="/newLogo/logo-mark-white.svg" alt="" width="20" height="20" class="w-5 h-5" />
      {{ $t("campagne.pageCagnotte.equipeDonoor") }}
    </p>
  </div>
</template>
